import { render, staticRenderFns } from "./EmployeeDetailsCardEmploymentsDialog.vue?vue&type=template&id=5108f330&scoped=true&"
import script from "./EmployeeDetailsCardEmploymentsDialog.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDetailsCardEmploymentsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeDetailsCardEmploymentsDialog.vue?vue&type=style&index=0&id=5108f330&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5108f330",
  null
  
)

export default component.exports